//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'InsureViewDetail',
  data() {
    return {
      applyInfo: [], // 申请信息
      detailList: {}, // 详情列表
      businessAddress: '', // 业务网点
      applyObjectList: [], // 适用对象
      addressList: [], // 地区
      companyName: '',
      productName: '',
    }
  },
  created() {
    this.businessAddress = this.$route.query.businessAddress
    this.companyName = this.$route.query.companyName
    this.productName = this.$route.query.productName
    this.getLoanIntentionSelectOneList()
  },
  methods: {
    getLoanIntentionSelectOneList() {
      let params = {
        id: this.$route.query.productId,
      }
      this.$http.insure.getInsureProductDetail(params).then((res) => {
        this.detailList = res.data
        let _detailList = this.detailList
        let _arr = []
        _detailList.applyObject.forEach((item) => {
          if (item == 1) {
            item = '种植户'
          } else if (item == 2) {
            item = '农户'
          } else if (item == 3) {
            item = '服务组织'
          } else if (item == 4) {
            item = '村集体'
          }
          _arr.push(item)
        })
        this.$set(this, 'addressList', _detailList.areaList)
        this.$set(this, 'applyObjectList', _arr)
        this.getInsureIntentionDetail()
      })
    },
    // 申请信息接口
    getInsureIntentionDetail() {
      let params = {
        id: this.$route.query.id,
      }
      this.$http.insure.getInsureIntentionDetail(params).then((res) => {
        this.$set(this, 'applyInfo', [res.data])
      })
    },
  },
}
